import { useState, useContext, useCallback } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

const useAuthApi = () => {
  const { baseUrl, basicAuth } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ================= GET USER ACCESS =================
  const getUserAccess = useCallback(
    async (userId) => {
      if (!baseUrl || !userId) return null;

      setLoading(true);
      setError(null);

      try {
        const response = await axios.post(
          `${baseUrl}/User/getUserAccess`,
          { userid: userId },
          {
            headers: {
              Authorization: basicAuth,
              "Content-Type": "application/json",
            },
          },
        );

        return response.data;
      } catch (err) {
        setError(err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [baseUrl, basicAuth],
  );

  // ================= SUBSCRIPTION DETAILS =================
  const fetchSubscriptionDetails = useCallback(
    async (userId) => {
      if (!baseUrl || !userId) return null;

      setLoading(true);
      setError(null);

      try {
        const response = await axios.post(
          `${baseUrl}/Entitlement/fetchSubscriptionDetails`,
          { userid: userId },
          {
            headers: {
              Authorization: basicAuth,
              "Content-Type": "application/json",
            },
          },
        );

        return response.data;
      } catch (err) {
        setError(err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [baseUrl, basicAuth],
  );

  return {
    loading,
    error,
    getUserAccess,
    fetchSubscriptionDetails,
  };
};

export default useAuthApi;
